import { useMemo } from 'react'
import useAsync from './useAsync'
import useSafeInfo from './useSafeInfo'
// import { getNativeTxns, type TokenTransfersTxns } from '@/utils/routescan'
import { useCurrentChain } from './useChains'
import { getTokenHistory, type TokenHistoryGrouped } from '@/utils/api'

const useNativeTransferHistory = (
  refreshCounter: number,
): {
  page?: TokenHistoryGrouped[]
  error?: string
  loading: boolean
} => {
  const { safeAddress } = useSafeInfo()
  const chainInfo = useCurrentChain()

  // If filter exists or pageUrl is passed, load a new history page from the API
  const [page, error, loading] = useAsync<TokenHistoryGrouped[]>(
    () => {
      if (!chainInfo || refreshCounter === 0) return

      return getTokenHistory(chainInfo.chainId, safeAddress)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [chainInfo, safeAddress, refreshCounter],
    false, // don't clear data between polls
  )

  return useMemo(
    () => ({
      page,
      error: error?.message,
      loading,
    }),
    [page, error, loading],
  )
}

export default useNativeTransferHistory
